import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, ArrowRight, Calendar } from "lucide-react";
import { useI18n } from "@/i18n";
import api from "@/lib/api";

export default function News() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get(`/news?lang=${lang}`).then((r) => setItems(r.data)).finally(() => setLoading(false)); }, [lang]);

  return (
    <div>
      <section className="bg-th-blue th-pattern text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Newspaper className="w-9 h-9 text-th-gold mb-3" />
          <h1 className="font-display font-bold text-4xl sm:text-5xl">{t("news_title")}</h1>
          <p className="mt-3 text-white/75 max-w-2xl text-lg">{t("news_subtitle")}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {loading ? <p className="text-slate-500">{t("loading")}</p> : items.length === 0 ? (
          <p className="text-slate-500" data-testid="news-empty">{t("news_none")}</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7" data-testid="news-grid">
            {items.map((n) => (
              <Link to={`/noticias/${n.id}`} key={n.id} data-testid={`news-card-${n.id}`} className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-xl transition-all">
                {n.image_url && <div className="h-44 overflow-hidden"><img src={n.image_url} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>}
                <div className="p-5">
                  <div className="text-xs text-th-gold font-semibold uppercase tracking-wide flex items-center gap-1"><Calendar className="w-3 h-3" />{n.published_at ? new Date(n.published_at).toLocaleDateString(lang) : ""}</div>
                  <h3 className="mt-2 font-display font-semibold text-xl text-th-blue leading-snug">{n.title}</h3>
                  <p className="mt-2 text-sm text-slate-500 line-clamp-3">{n.body}</p>
                  <div className="mt-4 flex items-center text-th-blue font-medium text-sm group-hover:text-th-gold">{t("news_read")} <ArrowRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" /></div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
